import { ref, toRaw, toRefs } from "vue"
import { getFilterMenu, getLastDicList } from "@/api/database"
import { TResponse } from "@/module/common"
import { TGetDirectoryRequest, TLastdicType, TMenuType } from "@/module/database"
import { ElMessage } from "element-plus"
import store from "@/store"

function dataInit() {
    let menuList = ref<TMenuType[]>()
    let secondLevelMenu = ref<TMenuType[]>()

    let list = ref<TMenuType[]>()
    let isOpen = ref(false)
    let subItem = ref<TMenuType[]>()
    let classIndex = ref(0)
    let subIndex = ref(0)
    let fileList = ref<TLastdicType[]>()
    let lastData = ref<TLastdicType[]>()


    // 左侧菜单&&&
    const getFilterMenus = (data: TGetDirectoryRequest): Promise<TMenuType[]> => {
        return new Promise(async (resolve, reject) => {
            let res: TResponse<TMenuType[]> = await getFilterMenu(data)
            try {
                if (res.Code == 200) {
                    //默认第一个数据
                    /* const items = res?.Data[0]?.Children
                    store.commit('setSecondLevelMenu', items) */
                    resolve(res.Data)

                }
            } catch (error) {
                reject(error)
            }
        })
    }
    // 获取班级筛选
    const getClassFilterMenus = async (data: TGetDirectoryRequest) => {
        var dd = data
        let res: TResponse<TMenuType[]> = await getFilterMenu(data)
        try {
            if (res.Code == 200) {
                list.value = res.Data
                subItem.value = []
                subIndex.value = 0
                //默认第一个数据
                // subItem.value = res.Data[0]?.Children
                // let data:Array<TMenuType> = toRaw(subItem.value) as Array<TMenuType>
                // if(data){
                //     let Id:number = data[0].Id
                // getDicList(dd.ParentId)
                // }
                // else{
                //     getDicList(dd.ParentId)

                // }
            }
        } catch (error) {
            ElMessage.warning('请求超时!')
        }
    }

    // 展开事件
    const onTigger = () => {
        isOpen.value = !isOpen.value
    }
    // 年级切换
    const onTabsSwitch = (index: number, row: TMenuType[], rowId: number) => {
        classIndex.value = index
        subIndex.value = 0
        subItem.value = row
        fileList.value = []
        let data: Array<TMenuType> = toRaw(row) as Array<TMenuType>
        // let Id:number = data[0].Id
        getDicList(rowId)

    }
    // 切换分类
    const onSubSwitch = async (index: number, Id: number) => {
        subIndex.value = index
        getDicList(Id)
    }

    // 获取文件夹列表
    const getDicList = (Id: number): Promise<TLastdicType[]> => {
        return new Promise(async (resolve, reject) => {
            let res: TResponse<TLastdicType[]> = await getLastDicList({ Id })
            try {
                if (res.Code == 200) {
                    resolve(res.Data)
                }
            } catch (error) {
                reject(error)
            }
        })
    }

    return {
        list,
        menuList,
        isOpen,
        subItem,
        classIndex,
        subIndex,
        fileList,
        secondLevelMenu,
        getFilterMenus,
        getClassFilterMenus,
        onTigger,
        onTabsSwitch,
        onSubSwitch,
        getDicList,
    }
}

export {
    dataInit
}

